<template>
  <div>
    <h1>{{ $t('azure-dashboard') }}</h1>
    <router-view />
  </div>
</template>
